import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Drawer/drawer';
import { css } from '@patternfly/react-styles';
import { DrawerMain } from './DrawerMain';
export var DrawerContent = function DrawerContent(_a) {
  var _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      children = _a.children,
      panelContent = _a.panelContent,
      props = __rest(_a, ["className", "children", "panelContent"]);

  return React.createElement(DrawerMain, null, React.createElement("div", Object.assign({
    className: css(styles.drawerContent, className)
  }, props), children), panelContent);
};